import { useContext, useEffect } from 'react';
import { useCountUp } from 'use-count-up';
import themeContext from '../context/theme/themeContext';
import { formatPercentages } from '../helpers/formats';

interface BarChartProps {
    type?: 'horizontal';
    className?: string;
    value?: number | string;
    total?: number | string;
    text?: string;
    isCounting?: boolean;
}

const BarChart: React.FC<BarChartProps> = ({
    type = 'horizontal',
    className = '',
    value = 0,
    total = 100,
    isCounting = true,
    text = undefined,
}) => {
    const { value: counterValue, reset } = useCountUp({
        isCounting,
        start: 0,
        end: +value,
        duration: 1,
    });

    const percentage = (counterValue ? +counterValue : +value) / +total;

    const { theme } = useContext(themeContext);

    useEffect(() => {
        if (!isCounting) {
            reset();
        }
    }, [isCounting, reset]);

    return (
        <div className={`bar-chart ${theme} ${type} ${className}`}>
            <div className='current-value' style={{ width: `${percentage * 100}%` }} />
            <span>{text ?? `${formatPercentages(percentage * 100 || 0)}%`}</span>
        </div>
    );
};

export default BarChart;
